/**
 * Subscription duration presets — UI labels only.
 * Persisted value is organization.account_expiration_day (int).
 * 30 is shared by Trial - 30 Days and Essentials - Monthly; reverse-map prefers trial.
 */

export const SUBSCRIPTION_DURATION_LABELS = {
  14: 'Trial - 14 Days',
  30: 'Trial - 30 Days',
  90: 'Essentials - Quarterly',
  365: 'Essentials - Annual',
  730: 'Essentials - 2 Years',
};

export const getSubscriptionDurationLabel = (accountExpirationDay) => {
  const days = Number(accountExpirationDay);
  if (Number.isFinite(days) && SUBSCRIPTION_DURATION_LABELS[days]) {
    return SUBSCRIPTION_DURATION_LABELS[days];
  }
  return 'Essentials - Annual';
};
